import React from "react";

interface ValueInTheRoomLegendProps {
  labels: string[];
  colors: string[];
}

const ValueInTheRoomLegend = ({ labels, colors }: ValueInTheRoomLegendProps) => {

  return (
    <div className="bg-panel-light">
      {labels.map(
        (label, i) => (
          <div
            key={i}
            className="d-flex align-items-center justify-content-between border-top px-3 py-1"
          >
            <div className="d-flex align-items-center">
              <div
                className="c-vitr__color-circle"
                style={{
                  backgroundColor: colors[i % colors.length],
                }}
              >
              </div>
              <div className="mx-2">{label}</div>
            </div>
          </div>
        ))}
    </div>
  );

};

export default ValueInTheRoomLegend;
